import { render, staticRenderFns } from "./LessorTrafficRefactored.vue?vue&type=template&id=60f49c33&"
import script from "./LessorTrafficRefactored.vue?vue&type=script&lang=js&"
export * from "./LessorTrafficRefactored.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports